/* here&found — STRAPO use-illustration (assets/hf-mechanism-strapo.js).
   Verb: SECURES. A loose woven bungee loops around a suitcase handle, a
   second bag passes through the outer loop, the buckle shortens the span,
   and both bags roll as one load.

   Product cues: wide striped webbing, two black elastic end loops and a
   rectangular adjustment buckle. Light stage; cobalt is reserved for one
   centre stripe and the final secured mark. */

const K = window.HFIllo.kit;
const { q, boxFill, Sh, Hand, st, INK, CREAM, Spark } = K;
const COBALT = (getComputedStyle(document.documentElement).getPropertyValue('--accent-deep') || '#1B54D6').trim();

const FLOOR_Y = 278;

function suitcase() {
  return `
    ${Sh(353, FLOOR_Y - 2, 88, 8)}
    <path d="${boxFill(288, 126, 132, 146, 4)}" fill="${CREAM}" stroke="${INK}" stroke-width="2.8"/>
    <path ${st(INK, 2.5)} d="${q(325, 126, 325, 72, 2)} ${q(383, 126, 383, 72, -2)} ${q(325, 72, 383, 72, 2)}"/>
    <circle cx="312" cy="276" r="8" fill="${CREAM}" stroke="${INK}" stroke-width="2.2"/>
    <circle cx="397" cy="276" r="8" fill="${CREAM}" stroke="${INK}" stroke-width="2.2"/>
    <path ${st(INK, 1.5)} d="${q(304, 151, 404, 149, 2)} ${q(304, 247, 404, 245, -2)}"/>`;
}

function duffel(y = 174) {
  return `
    ${Sh(212, y + 76, 72, 7)}
    <path d="M140 ${y + 14} Q148 ${y} 164 ${y} L256 ${y + 2} Q276 ${y + 5} 283 ${y + 24}
      L291 ${y + 65} Q254 ${y + 77} 210 ${y + 74} Q170 ${y + 78} 132 ${y + 66}
      L136 ${y + 28} Q137 ${y + 20} 140 ${y + 14} Z"
      fill="${CREAM}" stroke="${INK}" stroke-width="2.8" stroke-linejoin="round"/>
    <path ${st(INK, 2.2)} d="${q(168, y + 4, 186, y - 30, 4)} ${q(186, y - 30, 224, y - 28, 2)} ${q(224, y - 28, 244, y + 4, -4)}"/>`;
}

/* The webbing is drawn as a broad curved path with three parallel weave
   strokes; the elastic end loops stay unmistakably circular. */
function strapo(stage) {
  const loose = stage === 'loose';
  const looped = stage === 'looped';
  const loaded = stage === 'loaded';
  const tight = stage === 'tight' || stage === 'roll';
  const d = loose
    ? q(88, 160, 254, 140, 18)
    : q(338, 96, loaded || tight ? 220 : 274, loaded || tight ? 162 : 132, -18);
  const d2 = loose
    ? q(88, 172, 254, 152, 18)
    : q(342, 108, loaded || tight ? 224 : 278, loaded || tight ? 174 : 144, -18);
  return `
    <path ${st(INK, 12)} d="${d}"/>
    <path ${st(CREAM, 7)} d="${d}"/>
    <path ${st(COBALT, 2.6)} d="${d}"/>
    <path ${st(INK, 12)} d="${d2}"/>
    <path ${st(CREAM, 7)} d="${d2}"/>
    <path ${st(COBALT, 2.6)} d="${d2}"/>
    ${loose
      ? `<ellipse cx="72" cy="166" rx="26" ry="31" fill="none" stroke="${INK}" stroke-width="4"/>
         <ellipse cx="270" cy="146" rx="26" ry="31" fill="none" stroke="${INK}" stroke-width="4"/>`
      : `<ellipse cx="354" cy="92" rx="30" ry="28" fill="none" stroke="${INK}" stroke-width="4"/>
         <ellipse cx="${tight ? 202 : 258}" cy="${tight ? 170 : 140}" rx="28" ry="31" fill="none" stroke="${INK}" stroke-width="4"/>`}
    <!-- rectangular adjustment buckle -->
    <path d="${boxFill(loose ? 158 : 286, loose ? 143 : 117, 36, 28, 2.8)}" fill="${CREAM}" stroke="${INK}" stroke-width="3"/>
    <path ${st(INK, 1.8)} d="${q(loose ? 176 : 304, loose ? 146 : 120, loose ? 176 : 304, loose ? 168 : 142, 1)}"/>`;
}

const POSES = {
  loose: () => room() + suitcase() + strapo('loose'),
  loop: () => room() + suitcase() + strapo('looped') + Hand(270, 144, -18),
  load: () => room() + suitcase() + duffel(174) + strapo('loaded') + Hand(220, 172, 12),
  tighten: () => room() + suitcase() + duffel(174) + strapo('tight') + Hand(300, 132, -8),
  roll: () => room() + `<g transform="translate(16 0)">${suitcase()}${duffel(174)}${strapo('roll')}</g>`
    + Spark(442, 246, COBALT, .8),
};

function room() {
  return `<path ${st(INK, 2.6)} d="${q(28, FLOOR_Y, 500, FLOOR_Y - 4, 2.5)}"/>
    <!-- one travel cue: a small route card -->
    <path d="${boxFill(58, 68, 86, 54, 2.4)}" fill="${CREAM}" stroke="${INK}" stroke-width="2.2"/>
    <path ${st(INK, 1.5)} d="${q(71, 105, 94, 82, 3)} ${q(94, 82, 122, 105, -3)}"/>`;
}

window.HFIllo.register('strapo', {
  label: 'A woven bungee loops around a suitcase handle, holds a second bag and tightens so both bags roll together',
  night: false,
  settled: 'roll',
  phases: [['loose', 850], ['loop', 650], ['load', 750], ['tighten', 650], ['roll', 1900]],
  tags: {
    loose: 'Two loops, one adjustable strap',
    loop: 'Loop the suitcase handle',
    load: 'Pass the second bag through',
    tighten: 'Adjust from 50–64 cm',
    roll: 'Both bags, one load',
  },
  draw: (name) => (POSES[name] || POSES.roll)(),
});

window.HFIllo.define();
